import styles from './FeaturesGrid.module.css';
import { SectionWrapper } from '../shared/SectionWrapper';
import { Chip } from '../shared/Chip';
import { ScriptText } from '../shared/ScriptText';
import { GrainOverlay } from '../shared/GrainOverlay';
import { PhoneMockup } from '../shared/PhoneMockup';
import { features } from '../../data/features';

function parseTag(tag: string): { idx: string; label: string } {
  const parts = tag.split(' / ');
  if (parts.length >= 2) {
    return { idx: parts[0].trim(), label: parts.slice(1).join(' / ').trim() };
  }
  return { idx: '', label: tag };
}

export function FeaturesGrid() {
  return (
    <SectionWrapper id="features" className={styles.section}>
      <GrainOverlay />
      <div className={styles.header}>
        <div>
          <Chip>What's Inside</Chip>
          <h2 className={`display ${styles.title}`}>
            Four ways to turn<br />up the <ScriptText rotate={-2}>heat.</ScriptText>
          </h2>
        </div>
        <p className={styles.desc}>
          Every feature is built so nothing happens unless you both want it.
          Safe, surprising, and genuinely fun.
        </p>
      </div>

      <div className={styles.layout}>
        <div className={styles.grid}>
          {features.map((f) => {
            const { idx, label } = parseTag(f.tag);
            return (
              <div key={f.tag} className={styles.card}>
                <div className={styles.tagBlock}>
                  {idx ? <span className={styles.tagIdx}>{idx}</span> : null}
                  <span className={styles.tagLabel}>{label}</span>
                </div>
                <h3 className={styles.cardTitle}>{f.title}</h3>
                <p className={styles.cardBody}>{f.body}</p>
                <div className={styles.meta}>{f.meta}</div>
              </div>
            );
          })}
        </div>

        <aside className={styles.phoneRail} aria-hidden="true">
          <PhoneMockup mode="fluid" />
        </aside>
      </div>
    </SectionWrapper>
  );
}
